export default __webpack_public_path__ + "static/media/user-tie.0646969d.svg";